import React, { useContext } from 'react';

import { Grid, Paper } from '@material-ui/core';

import { GlobalContext } from '../../../store';

import background from '../../../assets/images/placeholder-photo.jpg';
import playerIcon from '../../../assets/images/player-blank.svg';
import BackgroundImage from '../../../components/BackgroundImage';
import { ListItem } from './ListItem/ListItem';
import styled from 'styled-components';
import { px } from '../../../contrib/ui';

export const StaffHome = () => {
  const { adminClubs } = useContext(GlobalContext);

  const allClubs = Object.values(adminClubs.all);

  return (
    <StaffHomeStyled className="staff-home">
      <BackgroundImage src={background} className="staff-home-bg" alt="bg-image">
        <div className="admin-wrapper">
          <div className="clubs-picker-layout">
            {allClubs.length > 0 ? (
              <div className="club-picker">
                <Paper elevation={1} className="paper">
                  <h1>SELECT A CLUB</h1>

                  <div className="list-wrapper">
                    <ListItem imgSrc={playerIcon} name="My Clubhouse" />

                    <p className="section-label">ADMIN DASHBOARDS</p>

                    <div className="clubs-list">
                      <Grid className="grid" container={true} spacing={2}>
                        {allClubs.map(({ id, profileImage, name }) => (
                          <Grid className="grid-item" item={true} xs={12} sm={6} key={id}>
                            <ListItem imgSrc={profileImage} id={String(id)} name={name} />
                          </Grid>
                        ))}
                      </Grid>
                    </div>
                  </div>
                </Paper>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </BackgroundImage>
    </StaffHomeStyled>
  );
};

const StaffHomeStyled = styled.div`
  margin-bottom: ${px(15)};
`;
